export const toFixedInches = (value: number) =>
  Number((value / 25.4).toFixed(2));
